import { Box, Button } from '@mui/material'
import { loadMoreBoxSx } from '../styles/NotificationStyle'
import { LoadingDots } from '../../../helpers/utils'

export default function LoadMoreButton({ isLoading, onLoadMore }) {
  return (
    <Box sx={loadMoreBoxSx}>
      <Button
        size="small"
        onClick={onLoadMore}
        disabled={isLoading}
        variant="outlined"
        sx={{
          textTransform: 'none',
          color: '#666',
        }}
      >
        {isLoading ? <LoadingDots /> : 'Load more'}
      </Button>
    </Box>
  )
}
